import css from "./code/css"
import html from "./code/html"
import framework from "./code/framework"
import plugins from "./code/plugins"
import vue from "./code/vue"
import js from "./code/js"
import other from "./code/other"

export default {
    html,
    css,
    cut1: `
body {
    line-height: 1;
}
 `,
    framework,
    plugins,
    vue,
    js,
    other
} 